export const normalizeValue = (value?: string | null): string => value?.trim() ?? ''
